export * from '@primeuix/themes/material/inputtext';
export { default } from '@primeuix/themes/material/inputtext';
